"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var player_base_1 = require("@24i/player-base");
var _a = require('../../package.json'), packageName = _a.name, packageVersion = _a.version;
exports.Logger = new player_base_1.LogSource(packageName, packageVersion);
//# sourceMappingURL=index.js.map